import axios from './axios';

export const sendCompanyValidate = (data: any) => {
  return axios.post<any>('/merchant/flows/ksa/validate', data).then((res) => res.data);
};

export const smsOtp = (data: any) => {
  return axios.post<any>('/merchant/flows/ksa/smsotp', data).then((res) => res.data);
};

export const sendInitialData = (data: { utm: string; mobileNumber?: string }) => {
  return axios.post<any>('/initial', data).then((res) => res.data);
};
